<template>
  <div class="wrapper">
    <a-form
      :form="form"
      @submit.prevent="onSubmit"
      layout="vertical"
      class="form"
    >
      <a-form-item v-bind="errorsBind('non_field_errors')" />
      <a-row :gutter="16">
        <a-col :span="10">
          <a-form-item label="Numer płatności" v-bind="errorsBind('name')">
            <a-input
              v-model="form.name"
              auto-complete="off"
              placeholder="Numer płatności"
            >
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item label="Kwota" v-bind="errorsBind('amount')" required>
            <a-input v-model="form.amount" suffix="zł" />
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item
            label="Termin płatności"
            v-bind="errorsBind('deadline')"
            required
          >
            <date-picker class="fluid" v-model="form.deadline" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-button
      v-if="withRemoveIcon"
      @click="$emit('delete')"
      type="link"
      icon="delete"
      class="c-remove-button c-remove-button--to-left"
    />
  </div>
</template>

<script>
import FieldsHelper from '@/components/common/forms/FieldsHelper'

export default {
  extends: FieldsHelper,
  props: {
    withRemoveIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form {
  width: calc(100% - 56px);
}

.c-remove-button {
  margin-top: 2px;
}
</style>
